import { ValueChartDataProvider, ValueChartItem } from "../Components/PercentValueChart/ValueChart";
import { GeneralStatsResponseItem } from "../Api/GeneralStatsApi";

/**
 * Represents the data that we receive from the server. This data will be 
 * shown on a graph on the analytics page
*/
export default class GeneralStats implements ValueChartDataProvider {
    public readonly data: ValueChartItem[];
    public readonly total: number;

    constructor(
        data: GeneralStatsResponseItem[] = [],
        total: number = 0,
    ) {
        this.total = total;

        /**
        * The data shape used by the chart is different than the data that is sent to 
        * us from the server so we need to convert it.
        */
        this.data = data
            .map((item): ValueChartItem => ({
                name: "" + item.name,
                value: item.value,
                // the data that comes from the server is sometimes a string and sometimes a number
                children: item?.children?.map((child) => ({
                    name: "" + child.name,
                    value: child.value,
                })) || [],
            }))
            .sort((a, b) => a.value - b.value)

    }

    public getRawData(): ValueChartItem[] {
        return this.data;
    }

    public getChartTotal(): number {
        return this.total;
    }

    public getChartLabels(): string[] {
        return Object.values(this.getChartData()).map((item) => item.name);
    }

    public getChartData(): ValueChartItem[] {
        return this.data;
    }
}
